import React, {useState, useEffect} from 'react';
import Day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import PropTypes from 'prop-types';
import TagManagerService from 'services/TagManager';
import CartService from 'services/Cart';
import { sellerIdFood, expressFlag } from 'config';
import LoginService from "services/Login";
import AddressService from 'services/Address/';
import StorageService from 'services/StorageService';
import Loader from 'components/Loader';
import CartActions from 'actions/Cart';
import PubSub from 'services/PubSub/';
import ExpressDeliveryService from 'services/ExpressDelivery';
import AddressFactory from "factories/Address";
import { actionsType, ecommerce } from 'config/constants';
import Month from './Month';
import SliderDays from './SliderDays';
import DeliveryWindowsRadio from './DeliveryWindowsRadio';
import SalesChannel from 'services/SalesChannel';
import CMSService from 'services/CMS/';
import { expressShipping, earlyCallTime } from 'config';
import NewRelicService from 'services/NewRelic';
import CMSFactory from 'factories/CMS';
import style from './style.scss';//NOSONAR


let deliveryWindow = {};
let express = {
    time: null,
    sc: null,
    validate: null,
    selected: false,
};
let sellerId = null;
let addressId = null
let callbackSelected = null;
let currentTime = null;
let operations = null;

const DateDelivery = ({value}) => {
    const [hours, setHours] = useState([]);
    const [orderForm, setOrderForm] = useState(null);
    const [datesOrderForm, setDatesOF] = useState(null);
    const [daySelected, setDaySelected] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [date, setDate] = useState(null);
    const [availableDeliveryWindows, setDeliveryWindows] = useState(null);
    const [title, setTitle] = useState(null);
    const [showDays, setShowDays] = useState(false);
    const [selectExpress, setSelectExpress] = useState(false);
    const [messageEarlyCall, setMessageEarlyCall] = useState(false);
    const [configRestriction, setConfigRestriction] = useState(null);
    const isSellerFood = ecommerce.whiteLabel || sellerId === sellerIdFood;

    useEffect(() => {
        setShowDays(false);

        setTimeout(() => {
            setShowDays(true);
        }, 0);
    },[date]);


    useEffect(() => {
        let deliverySelected = getDeliveryWindow(orderForm);

        if(deliverySelected && (deliverySelected !== {}) && deliverySelected.startDateUtc){
            setDaySelected(deliverySelected.startDateUtc.split('T')[0]);
            _getHours(deliverySelected.startDateUtc.split('T')[0], deliverySelected, true, undefined, operations);
        }
    },[orderForm && datesOrderForm]);

    useEffect(() => {
        if(express){
            setSelectExpress(express.selected)
        }
    }, [express && express.selected])


    useEffect(() => {
        _open(value);

        return function cleanup() {
            sellerId = null;
            addressId = null
            deliveryWindow = {};
            callbackSelected = null;
        }
    }, [value]);

    const _open = (data) => {
        if(!data) return null;

        if(data.orderForm){
            let dataOrderForm = {...data.orderForm};
            sellerId = data.sellerId ? data.sellerId : sellerIdFood;
            addressId = data.addressId;
            setOrderForm({...dataOrderForm});
        }
        if(data.title){
            setTitle(data.title)
        }
        if(data.deliveryWindows){
            setDeliveryWindows(data.deliveryWindows);
            callbackSelected = data.callbackSelected;
        }
    }

    const _initDays = (currentOF, operations) => {
        const sla = _getSla(currentOF);
        if ((sla && sla.availableDeliveryWindows && sla.availableDeliveryWindows.length) || availableDeliveryWindows) {
            const slaOrdered = _sortDateHour(sla.availableDeliveryWindows || availableDeliveryWindows);

            setDatesOF([...slaOrdered]);
            const onlyDays = dateDelivery([...slaOrdered]);
            StorageService.setItem('firstWindowAvailable', JSON.stringify(slaOrdered.length ? slaOrdered[0] : null));

            const dateInit = Day(slaOrdered[0].startDateUtc).format('YYYY-MM-DD');

            _getCompleteMonthDays(dateInit, onlyDays[0], onlyDays.pop(), slaOrdered, operations);
        } else {
            setTimeout(()=> PubSub.dispatch(actionsType.MODAL.DATE_DELIVERY_CLOSE),0)
        }
    }

    useEffect(() => {
        let method = StorageService.getItem('preselected_shipping_method');
        let homeDelivery = method ? ((method === 'seller-1-sla-DespachoaDomicilio') || (method === 'seller-1-sla-Express')) : null;

        setLoading(true);

        const consults = [
            CMSService.getDateTimeCache(),
            CMSService.getOperationsV2()
        ];

        Promise.all(consults).then(res => {
            currentTime = res[0];
            operations = res[1];
            setConfigRestriction(operations);

            if(homeDelivery && orderForm) {
                if(expressFlag){
                    const adress = orderForm ? orderForm.shippingData.address : null;
                    const logistic = (orderForm ? orderForm.shippingData.logisticsInfo : null);
                    const slaExpress = logistic ? logistic[0].slas.filter(item => item.id == 'Despacho Express') : null;
                    const lat = adress ? adress.geoCoordinates[1] : null;
                    const lng = adress ? adress.geoCoordinates[0] : null;

                    ExpressDeliveryService.assignAddress(lat, lng).then(data=> {
                        if(data && data.express_delivery && data.delivery_time && data.sales_channel){
                            data.listPrice = slaExpress[0] ? slaExpress[0].listPrice : 0;
                            _setDataExpress(slaExpress.length ? data : null, method);
                        } else {
                            _setDataExpress();
                        }
                        _initDays(orderForm, operations);
                        setLoading (false);
                    });
                } else {
                    _setDataExpress();
                    _initDays(orderForm, operations);
                    setLoading (false);
                }
            } else {
                if(orderForm || availableDeliveryWindows){
                    _setDataExpress();
                    _initDays(orderForm, operations);
                    setLoading (false);
                }
            }
        });

    }, [orderForm, availableDeliveryWindows]);

    const _setDataExpress = (data = null, method = null) => {
        if(data){
            express = {
                time: data.delivery_time,
                sc: data.sales_channel,
                validate: data.express_delivery,
                selected: method && method === 'seller-1-sla-Express',
                price: data.listPrice
            };
        }else{
            express = {
                time: null,
                sc: null,
                validate: null,
                selected: false
            };
        }
    }

    const dateDelivery = (dateOrderF) => {
        let day = [];

        if (!dateOrderF) return false;

        dateOrderF.map((item) => {
            const dateWeek = Day(item.startDateUtc).format('YYYY-MM-DD');
            if (day.indexOf(dateWeek) === -1) {
                day.push(dateWeek);
            }
        })
        let sortDay = day.slice().sort();
        return sortDay;
    }

    const _sortDateHour = (daysDelivery) => {
        return daysDelivery.sort((a, b) => {
            a = new Date(a.endDateUtc).getTime();
            b = new Date(b.endDateUtc).getTime();
            return a < b ? -1 : a > b ? 1 : 0;
        });
    }

    const _compareDays = (cur, selectedDay) => {
        const current = cur.datetime.split('T')[0]
        if (current === selectedDay) return true
        return false
    }

    const _filterFirstHour = (hour, selectedDay, operations = configRestriction) => {
        if (!(currentTime && value.orderForm)) return false;

        const isToday = _compareDays(currentTime, selectedDay)
        let endDateFirstWindow = hour && hour.length && Day.extend(utc)(hour[0].endDateUtc).utc().format('YYYY-MM-DDTHH:mm:ss');
        const current = currentTime.datetime
        let diff = Math.abs(Day(current).diff(endDateFirstWindow))
        const itemsQty = value.orderForm.items.reduce((oldValue, item) => (oldValue + item.quantity), 0);

        if (isToday && diff < expressShipping.closerWindow && itemsQty >= expressShipping.maxQtyOfProducts) {
            hour = hour.slice(1)
            endDateFirstWindow  = hour && hour.length && Day.extend(utc)(hour[0].endDateUtc).utc().format('YYYY-MM-DDTHH:mm:ss');
            diff = Math.abs(Day(current).diff(endDateFirstWindow))
        }

        if (hour && hour.length && diff <= expressShipping.timeLimitExpress) {
            hour[0]['formatExpress'] = true
        }

        let order = value?.orderForm?.items;

        let category = order.map((product) => {
            return product.productCategories
        })

        operations?.config_restricition && operations?.config_restricition.map((data) => {
            category.map((cat) => {
                if(cat[data.category]){
                    if(data.daily_interval){
                        let hourRestriction = data.daily_interval;
                        const todayFormat = Day().format('YYYY-MM-DD');
                        const restrictionStart = CMSFactory.milliseconds(Day(todayFormat + ('T') + hourRestriction.date_start).format('YYYY-MM-DDTHH:mm:ss'))
                        const restrictionEnd = CMSFactory.milliseconds(Day(todayFormat + ('T') + hourRestriction.date_end).format('YYYY-MM-DDTHH:mm:ss'))

                        hour = hour.filter((item) => {
                            const windowStart = CMSFactory.milliseconds(Day.extend(utc)(todayFormat + 'T' + item.startDateUtc.split('T')[1]).utc().format('YYYY-MM-DDTHH:mm:ss'));
                            const windowEnd = CMSFactory.milliseconds(Day.extend(utc)(todayFormat + 'T' + item.endDateUtc.split('T')[1]).utc().format('YYYY-MM-DDTHH:mm:ss'))

                            if((windowStart >= restrictionStart && windowStart <= restrictionEnd) || (windowEnd >= restrictionStart && windowEnd <= restrictionEnd )) {
                                return false;
                            } else {
                                return true;
                            }
                        })
                    }
                    if(data.scheduled_date) {
                        const dateRestrictionStart = CMSFactory.milliseconds(data.scheduled_date.date_start.replace(' ', 'T'));
                        const dateRestrictionEnd = CMSFactory.milliseconds(data.scheduled_date.date_end.replace(' ', 'T'));

                        hour = hour.filter((item) => {
                            const windowStart = CMSFactory.milliseconds(Day.extend(utc)(item.startDateUtc).utc().format('YYYY-MM-DDTHH:mm:ss'))
                            const windowEnd = CMSFactory.milliseconds(Day.extend(utc)(item.endDateUtc).utc().format('YYYY-MM-DDTHH:mm:ss'))

                            if((windowStart >= dateRestrictionStart && windowStart <= dateRestrictionEnd) || (windowEnd >= dateRestrictionStart && windowEnd <= dateRestrictionEnd )) {
                                return false;
                            } else {
                                return true;
                            }
                        })
                    }
                }
            })
        })

        return hour
    }

    const _getHours = (day, hourSelected = false, selected = false, slasOrdered = null, operations) => {
        let hour = [];
        setDaySelected(day ? day : '');
        const arrayDates = slasOrdered ? slasOrdered : datesOrderForm;
        if(arrayDates){
            arrayDates.forEach((item) => {
                const dayWithoutTime = item.startDateUtc.split('T')[0];
                item.selected = false;
                if (dayWithoutTime === day) {
                    if (hourSelected && (item.startDateUtc === hourSelected.startDateUtc) && (item.endDateUtc === hourSelected.endDateUtc)) {
                        item.selected = selected;
                    }
                    hour.push(item);
                }
            })
        }
        deliveryWindow = hourSelected;
        hour = _filterFirstHour(hour, day, operations) || hour;

        const _hours = hour && hour.filter(item => item.selected);
        if(!(_hours && _hours.length) && hour.length){
            hour[0].selected = true;
            _selectedHours(hour[0], true, false, false);
        }
        setHours([...hour]);
    }

    const getWindowsOrderForm  = (day) => {
        let hour = [];

        let dateOrderF = [];
        if(availableDeliveryWindows) {

            dateOrderF = availableDeliveryWindows;

        } else {
            let deliveryT = AddressService.getDeliveryMode(sellerId);
            const logisticsInfo = CartService.getLogisticsOF(orderForm, sellerId);
            let sla = AddressFactory.getSla(logisticsInfo, deliveryT === 'seller-1-sla-Express' ? 'seller-1-sla-DespachoaDomicilio' : deliveryT, addressId);
            dateOrderF = (sla && sla.length) ? sla[0].availableDeliveryWindows : [];
        }
        dateOrderF.map((item) => {
            const moment = Day(item.startDateUtc).format('YYYY-MM-DD');

            if (moment === day) {
                hour.push(item);
            }
            return item
        });
        return hour;
    }

    const _selectedHours = (hour, selected, daySel = false, updateHours = true) => {
        hour.selected = selected;
        let dateTime = Day.extend(utc)(hour.startDateUtc).utc().format('HH:mm:ss');
        if(dateTime <= earlyCallTime){
            setMessageEarlyCall(true);
        }else{
            setMessageEarlyCall(false);
        }
        if(updateHours){
            _getHours(daySel ? daySel : daySelected, hour, selected, undefined ,operations);
        }
        deliveryWindow = hour;
        express.selected = false;
    }


    const _getSla = (orderFormParam) => {
        if (!(orderFormParam && orderFormParam.shippingData)) return false;
        const logistics = CartService.getLogisticsOF(orderFormParam, sellerId);
        let deliveryT = AddressService.getDeliveryMode(!ecommerce.whiteLabel ? sellerId : null);
        const sla = AddressFactory.getSla(logistics, deliveryT === 'seller-1-sla-Express' ? 'seller-1-sla-DespachoaDomicilio' : deliveryT, addressId);
        return sla && sla.length ? sla[0] : null;
    }

    const changeDate = () => {
        NewRelicService.sendPageAction({
            action: 'changeDate',
            payload: {
                status: 'init',
                windowDateTime: deliveryWindow && deliveryWindow.startDateUtc ? deliveryWindow.startDateUtc + ' - ' + deliveryWindow.endDateUtc + ' - Server: '+ currentTime.datetime : ''
            }
        });
        if(availableDeliveryWindows && callbackSelected){
            setLoading(true);
            callbackSelected(deliveryWindow).then(() => {
                setLoading(false);
                callback();
            });
        } else {
            let deliveryT = AddressService.getDeliveryMode();
            let selectedSla = '';
            const logisticsInfo = CartService.getLogisticsOF(orderForm, sellerId);
            let deliveryChannel = 'pickup-in-point';

            if (deliveryT === 'seller-1-sla-DespachoaDomicilio' || deliveryT === 'seller-1-sla-Express') {
                deliveryChannel = 'delivery';
            }

            let windowSelected = hours.filter(item => item.selected);

            StorageService.setItem('deliverySelected', JSON.stringify(windowSelected.length ? windowSelected[0] : null));

            if(logisticsInfo){
                let newInfo = logisticsInfo.map(options => {
                    options.deliveryWindow = deliveryWindow;

                    options.slas = options.slas.map(sla => {
                        sla.selectedSla = 'Despacho Express';
                        let conditionStore = null;
                        let conditionCar = null
                        let conditionDelivery = null;
                        const validDeliverySpecial = sla.id.includes('Despacho Especial') && (options.slas.findIndex(item => item.id.includes('Despacho a Domicilio')) === -1);

                        if(ecommerce.whiteLabel){
                            conditionStore = (((addressId && sla.id.includes(addressId) && sla.id.includes('Retiro en Tienda')) || (!addressId && isSellerFood && sla.id.includes('Retiro en Tienda'))) && (deliveryT === 'seller-1-sla-RetiroenTienda'))
                            conditionCar = (((addressId && sla.id.includes(addressId) && sla.id.includes('Click al Auto')) || (!addressId && sla.id.includes('Click al Auto'))) && (deliveryT === 'seller-1-sla-ClickalAuto'))
                            conditionDelivery = ((sla.id.includes('Despacho a Domicilio') || validDeliverySpecial) && deliveryT === 'seller-1-sla-DespachoaDomicilio')
                        }else{
                            conditionStore = (((!isSellerFood && sla.id.includes(addressId)) || (isSellerFood && sla.id.includes('Retiro en Tienda'))) && (deliveryT === 'seller-1-sla-RetiroenTienda'))
                            conditionCar = (sla.id.includes('Click al Auto') && deliveryT === 'seller-1-sla-ClickalAuto');
                            conditionDelivery = ((sla.id.includes('Despacho a Domicilio') || validDeliverySpecial) && ((deliveryT === 'seller-1-sla-DespachoaDomicilio' || deliveryT === 'seller-1-sla-Express') && !express.selected))
                        }

                        if (conditionStore) {
                            sla.deliveryWindow = deliveryWindow;
                            sla.selectedSla = sla.id;
                            sla.selectedDeliveryChannel = deliveryChannel;
                            selectedSla = sla.id;
                        }
                        if (conditionCar) {
                            sla.deliveryWindow = deliveryWindow;
                            sla.selectedSla = sla.id;
                            sla.selectedDeliveryChannel = deliveryChannel;
                            selectedSla = sla.id;
                        }
                        if (conditionDelivery) {
                            sla.deliveryWindow = deliveryWindow;
                            sla.selectedSla = sla.id;
                            sla.selectedDeliveryChannel = deliveryChannel;
                            selectedSla = sla.id;
                        }
                        if ((sla.id.includes('Despacho Express')) && express.selected) {
                            sla.deliveryWindow = null;
                            sla.selectedSla = sla.id;
                            sla.selectedDeliveryChannel = deliveryChannel;
                            selectedSla = sla.id;
                        }
                        return sla;
                    });

                    options.selectedSla = selectedSla;
                    options.selectedDeliveryChannel = deliveryChannel;

                    return options;
                });
                setLoading(true);

                let address = orderForm ? orderForm.shippingData.address : null;

                if(deliveryT === "seller-1-sla-DespachoaDomicilio" || deliveryT === "seller-1-sla-Express") {
                    if(address){
                        address.receiverName =  getReceiverName();
                    }
                    if(orderForm) {
                        const userDataOF = {
                            document: orderForm.clientProfileData.document,
                            firstName: orderForm.clientProfileData.firstName,
                            lastName: orderForm.clientProfileData.lastName
                        }
                        CartActions.setUserReceiver(userDataOF);
                    }
                }else if(address) {
                    address.receiverName = address.receiverName || getReceiverName();
                }

                if(express.selected) {
                    const neighborhood = orderForm ? orderForm.shippingData.address.neighborhood : null;
                    StorageService.setItem('delivery_time', express.time);
                    AddressService.newSetDeliveryMode('seller-1-sla-Express', neighborhood, express.sc, true, address).then(() => {
                        updateShipping(address, newInfo)
                    })
                } else {
                    if(deliveryT === 'seller-1-sla-Express' && !express.selected){
                        const neighborhood = orderForm ? orderForm.shippingData.address.neighborhood : null;
                        const sc = SalesChannel.getSalesChannel();
                        AddressService.newSetDeliveryMode('seller-1-sla-DespachoaDomicilio', neighborhood, sc, true, address).then(() => {
                            updateShipping(address, newInfo);
                        });
                    }else{
                        updateShipping(address, newInfo);
                    }

                }
            }
        }
    }

    const updateShipping = (_address, _newInfo) => {
        const tagManager = {
            action: 'Problema al seleccionar ventana',
            tag: deliveryWindow ? Day(deliveryWindow.startDateUtc).format('DD-MM-YYYY') + ' ' + Day.extend(utc)(deliveryWindow.startDateUtc).utc().format('HH:mm') : '',
            category: 'Errores shipping',
        }

        CartActions.updateShippingData(_address, _newInfo).then((results) => {
            if(!results || results.status) TagManagerService.interaction(tagManager.action, tagManager.tag, tagManager.category);

            setLoading(false);
            callback(false);

            NewRelicService.sendPageAction({
                action: 'changeDate',
                payload: {
                    status: 'Success',
                    windowDateTime: deliveryWindow && deliveryWindow.startDateUtc ? deliveryWindow.startDateUtc + ' - ' + deliveryWindow.endDateUtc : ''
                }
            });

            const first = StorageService.getItem('firstWindowAvailable');
            const firstDeliveriesWindows = first ? JSON.parse(first) : '';

            NewRelicService.sendPageAction({
                action: 'firstWindowAvailable',
                payload: {
                    windowDateTime: firstDeliveriesWindows && firstDeliveriesWindows.startDateUtc ? firstDeliveriesWindows.startDateUtc + ' - ' + firstDeliveriesWindows.endDateUtc : ''
                }
            });

        }).catch(() => {
            setLoading(false);
            NewRelicService.sendPageAction({
                action: 'changeDate',
                payload: {
                    status: 'ShippingFail',
                    windowDateTime: deliveryWindow && deliveryWindow.startDateUtc ? deliveryWindow.startDateUtc + ' - ' + deliveryWindow.endDateUtc : ''
                }
            });
            TagManagerService.interaction(tagManager.action, tagManager.tag, tagManager.category);
        }) ;
    }

    const getReceiverName = () => {
        const userData = LoginService.getUserData();
        return userData ? `${userData.firstName} ${userData.lastName}` : null;
    };

    const callback = (bool) => {
        if (!bool){
            setTimeout(()=> PubSub.dispatch(actionsType.MODAL.DATE_DELIVERY_CLOSE),0);
        }
        setTimeout(()=>  PubSub.dispatch('cart_update_title',{title: 'Checkout'}),0);
    }

    const getDeliveryWindow = (currentOF) => {
        if (!(currentOF && currentOF.shippingData && currentOF.shippingData.logisticsInfo)) return null;

        const logisticsInfo = CartService.getLogisticsOF(currentOF, sellerId)[0];
        const sla = logisticsInfo ? logisticsInfo.slas.filter(itemSla => itemSla.deliveryWindow).filter(Boolean) : [];

        return sla && sla.length ? sla[0].deliveryWindow : null;
    }

    const _getCompleteMonthDays = (newMonth = false, firstDay = null, lastDate = null, slasOrdered = null, operations) => {
        let currentDate = null;
        let dateNow = Day(newMonth);
        let deliverySelected = getDeliveryWindow(orderForm);

        let lastDay =  (newMonth ?  Day(newMonth).endOf('month').format('D') : Day().endOf('month').format('D')) * 1;
        let currentDay = (newMonth ? Day(newMonth).format('D') : Day().format('D')) * 1;

        let dateAux = [];
        const lastDayOfMonth = Day(lastDate).endOf('month').format('YYYY-MM-DD');
        const diffDays = Day(lastDayOfMonth).diff(Day(newMonth),'days');

        for(let i = 0; i <= (diffDays ? (diffDays * 1) : (lastDay - currentDay)); i++) {
            const datesFormat = dateNow.add(i, 'days').format('YYYY-MM-DD');
            dateAux.push(datesFormat);
        }

        const dates = _getDateExpress(dateAux);

        if(firstDay && (dates[0] < firstDay)){
            firstDay = dates[0];
        }

        if(newMonth && (Day(newMonth).format('YYYY-MM') === Day().format('YYYY-MM'))){
            currentDate = deliverySelected ? Day((deliverySelected && deliverySelected.startDateUtc) ? deliverySelected.startDateUtc.split('T')[0] : null) : (firstDay ? Day(firstDay) : Day());
        }else if(newMonth && (Day(newMonth).format('YYYY-MM') !== Day().format('YYYY-MM'))){

            currentDate = Day(firstDay);
            dateNow = Day(newMonth);


        }else{
            currentDate = express.validate && !deliverySelected ? Day() : (firstDay ? Day(firstDay) : Day());
        }

        _getHours(currentDate.format('YYYY-MM-DD'), deliverySelected, true, slasOrdered, operations );

        setDate(dates);
    }

    const _getDateExpress = (dateItem) => {
        if(dateItem){
            let dateAux = [...dateItem];
            if(dateAux[0] !==  today && express.validate){
                dateAux = [today].concat(dateAux);
            }
            return dateAux;
        }

        return dateItem;
    }

    const validateExpress = () => {
        if (express) {
            express.selected = !express.selected;
            setHours(prevState => prevState.map((item) => {
                item.selected = false;
                return item;
            }))
        }
    }

    let isSelected = hours && hours.length > 0 ? hours : [];
    isSelected = (isSelected.findIndex(item => item.selected) !== -1) || (express && express.selected);

    const today = Day().format('YYYY-MM-DD');

    return (
        <div className="new-modal-container">
            {isLoading && <div className="date-delivery-loader"><Loader /></div>}
            <div className="new-modal-title-wrap"><span className="new-modal-title">{title ? title : 'Horario de entrega'}</span></div>
            <div className="new-modal-scroll">
                <Month daySelected={daySelected}/>

                <div className="date-delivery-select-day">Selecciona una fecha</div>

                {showDays && <SliderDays days={date} expressValidate={(express && express.validate)} getHours={_getHours} daySelected={daySelected} getWindowsOrderForm={getWindowsOrderForm}/>}

                {!!(hours && hours.length) || ((express && express.validate) && (daySelected === today)) && daySelected ? <div className="date-delivery-select-hours">
                    Selecciona el horario para la entrega
                </div> : ''}
                {messageEarlyCall && <div className='delivery-selector-error-msg early'>{" Tu pedido podría ser preparado  "}<strong>{"desde las 8:00 AM, "}</strong>{" por lo que podrías ser contactado por el shopper a partir de esa hora"}</div>}
                {((express && !express.validate) && (!hours || !hours.length) && daySelected) && <div className="date-delivery-hours-not-available">
                    <span className="date-delivery-hours-not-available-text">No tenemos horarios de entrega disponibles para esta jornada</span>
                    <span className="date-delivery-change-day-text">Por favor, intenta con otro día</span>
                </div>}
                <DeliveryWindowsRadio hours={hours} daySelected={daySelected} selectExpress={selectExpress} express={express} validateExpress={validateExpress} selectedHours={_selectedHours}/>

            </div>

            {hours && <div className="modal-actions">
                <button onClick={() => {callback(false)}} className="secundary-btn date-delivery-canceled-button">Cancelar</button>
                <button onClick={() => changeDate()} className={"disabled-btn date-delivery-selected-button" + (isSelected ? ' primary-btn ' : '')}>Seleccionar</button>
            </div>}
        </div>
    )
}

DateDelivery.propTypes = {
    value: PropTypes.object
};

export default DateDelivery;
